import React, { useState, useEffect } from "react";
import { AddCustomerSupport, uploadFile } from "../../DAL/create";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  TextField,
  MenuItem,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import SVGAAnimation from "../../Components/SVGAAnimation";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchCategoriesList,
  fetchProductDetail,
  GetCustomerDetail,
  GetProductDetail,
} from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import { updateCustomerData, updateSingleProductData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";
import { formatDate } from "../../Utils/Formatedate";

const menuItems = [
  "technical_issues",
  "business_developer_support",
  "payments_billing",
  "account_profile",
  "rewards_referrals",
  "app_features_suggestions",
  "terms_policies_legal",
  "regional_language_support",
  "general_queries",
];

function AddCustomer() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [fileName, setFileName] = useState("");
  const [file2, setFile2] = useState(null);
  const [fileName2, setFileName2] = useState("");
  const [fileUploaded1, setFileUploaded1] = useState(false);
  const [fileUploaded2, setFileUploaded2] = useState(false);
  const [fileURL1, setFileURL1] = useState("");
  const [fileURL2, setFileURL2] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [filePreview2, setFilePreview2] = useState(null);
  const [name, setName] = useState("");
  const [prices, setPrices] = useState({ 1: 0, 7: 0, 15: 0, 30: 0 });
  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [type, setType] = useState("");
  const [types, setTypes] = useState("add");
  const [message, setMessage] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedItem, setSelectedItem] = useState("");

  const handleChange = (event) => {
    setSelectedItem(event.target.value);
  };
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await GetCustomerDetail(id);
        if (response?.data?.data) {
          const product = response?.data?.data;
          setName(product?.name || "");
          setEmail(product?.email || "");
          setPhone(product?.phone || "");
          setPassword(product?.password || "");
          setSelectedItem(product?.technicalRoles?.role || "");
          setFileURL1(product?.picture?.id || "");
          if (product?.picture) {
            setFilePreview(fileUrl + product?.picture?.url);
          }
          setTypes("edit");
        }
      } catch (error) {
        console.error("Failed to fetch Customer Support details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetchCategoriesList();
        const data = response.data.data;
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      setFile(selectedFile); // this is the binary file object
    }
  };

  const handleFileSubmit1 = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage(true);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    try {
      const imagedata = await uploadFile(formData);
      setFileURL1(imagedata.data.id);
      setFileUploaded1(true);
      enqueueSnackbar("File uploaded successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      enqueueSnackbar("Failed to upload file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name,
      email,
      phone,
      password,
      file: file,
    };

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("technicalRole", selectedItem);
    formData.append("file", file);

    setLoading(true);
    try {
      const resp =
        types == "add"
          ? await AddCustomerSupport(formData)
          : await updateCustomerData(id, formData);

      if (resp?.status == 200) {
        enqueueSnackbar(
          types == "add"
            ? "CSR added successfully"
            : "CSR updated successfully",
          { variant: "success" }
        );
        navigate("/customer-list");
      } else {
        enqueueSnackbar(
          resp?.message ||
            resp?.error ||
            resp?.data?.message ||
            resp?.data?.error,
          { variant: "error" }
        );
        setMessage(true);
      }
    } catch (error) {
      console.error("Error uploading CSR:", error);
      enqueueSnackbar("Failed to upload CSR. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
        maxWidth: 400,
        margin: "auto",
        mt: 4,
      }}
    >
      <Typography variant="h6">
        {types == "add" ? "Create Customer Support" : "Update Customer Support"}
      </Typography>
      <TextField
        fullWidth
        required
        label="Name"
        variant="outlined"
        value={name}
        onChange={(e) => setName(e.target.value)}
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />
      {/* <FormHelperText sx={{ color: "red" }}>
        {message == true && !file && "name is required"}
      </FormHelperText> */}
      <TextField
        fullWidth
        required
        label="Email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />
      {/* <FormHelperText sx={{ color: "red" }}>
        {message == true && !file && " email is required"}
      </FormHelperText> */}
      <TextField
        fullWidth
        required
        label="Phone no"
        variant="outlined"
        value={phone}
        onChange={(e) => {
          const val = e.target.value;
          if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0)) {
            setPhone(val);
          }
        }}
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />
      <TextField
        fullWidth
        required
        label="password"
        variant="outlined"
        type="number"
        value={password}
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />

      <Box sx={{ width: 400, p: 2 }}>
        <FormControl fullWidth>
          <InputLabel id="menu-select-label" fullWidth>
            Select Topic
          </InputLabel>
          <Select
            labelId="menu-select-label"
            value={selectedItem}
            label="Select Topic"
            onChange={handleChange}
          >
            {menuItems.map((item, index) => (
              <MenuItem key={index} value={item}>
                {item
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (l) => l.toUpperCase())}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* {selectedItem && (
          <Typography mt={2}>
            Selected:{" "}
            <strong>
              {selectedItem
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase())}
            </strong>
          </Typography>
        )} */}
      </Box>

      <Typography variant="h6">Upload Image *</Typography>

      <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <Button
          variant="contained"
          color={fileUploaded1 ? "success" : "primary"}
          onClick={handleFileSubmit1}
          disabled={loading || !file}
          sx={{ textTransform: "none" }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : fileUploaded1 ? (
            "Uploaded"
          ) : (
            "Upload"
          )}
        </Button>
      </Box>
      {fileName && <Typography variant="body2">{fileName}</Typography>}
      {/* <FormHelperText sx={{ color: "red" }}>
        {message == true && !file && "Image file is required"}
      </FormHelperText> */}

      {filePreview && (
        <Box sx={{ mt: 2 }}>
          <img
            src={filePreview}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "200px" }}
          />
        </Box>
      )}

      <Button
        variant="contained"
        className="gradientButton"
        onClick={handleSubmit}
        fullWidth
        sx={{ marginBottom: "20px", textTransform: "none" }}
      >
        Submit
      </Button>
    </Box>
  );
}

export default AddCustomer;
